import {switchMap, map, first} from 'rxjs/operators';
import {Component, Input, OnInit} from '@angular/core';
import {FmcElementsComponent} from '../fmc-elements.component';
import {UntypedFormControl, AbstractControl, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LookupService} from '../services/lookup.service';
import {timer, EMPTY as empty, of as observableOf} from 'rxjs';
import {NgIf} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'fmc-sensis-email',
  templateUrl: './sensis-email.component.html',
  styleUrls: ['./sensis-email.component.css'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule
  ]
})
export class SensisEmailComponent extends FmcElementsComponent implements OnInit {
  @Input() public centralisedValidation = false;
  public defaultControl = new UntypedFormControl();
  public defaultControlType = 'FormControl';

  ngOnInit() {
    super.ngOnInit();

    if (!this.centralisedValidation && !this.notRequired) {
      this.formControl.setAsyncValidators(this.emailValidation(this.lookupService));
    }
  }

  public emailValidation(auxService: LookupService): any {
    return (control: AbstractControl): { [key: string]: any } => {

      if (control.value === null || control.value === undefined || control.value === '') {
        // @ts-ignore
        return empty.toPromise();
      }

      if (!/^\S*[@]\S*[.]\S*$/.test(control.value)) {
        return observableOf(false).pipe(map(result => result ? {email: false} : {email: null}));
      }

      return timer(1000).pipe(switchMap(() => {
        return auxService.sensisVerifyEmail(control.value).then((res) => {
          if (res && res.result && res.result['domain_exists'] !== 'VALID' && res.result['email_valid'] !== 'VALID') {
            return {email: true};
          } else {
            this.formControl.setErrors(null);
            return null;
          }
        }, (err) => {
          // disableSubmit.next(false);
        });
      }));
    };
  }
}
